import Vuex from 'vuex'
import Vue from 'vue'
import api from '@/api'
import { format } from 'date-fns'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('token'),
    user: null,
    locations: null,
  },

  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    setUser(state, user) {
      state.user = user
    },
    setLocations(state, locations) {
      state.locations = locations
    },
  },

  actions: {
    async login({ commit, dispatch }, { email, password }) {
      const data = await api.post('/login', { email, password })
      commit('setToken', data.token)
      await dispatch('loadUserSession', data)
    },

    async loadUserSession({ commit, state, dispatch }) {
      const user = await api.get(`/me`, state.token)
      if (!user.id) return
      commit('setUser', user)
      await dispatch('refreshLocations')
    },

    async logout() {
      localStorage.removeItem('token')
      window.location.reload()
    },

    async resetPasswordEmail(_, email) {
      const reset = await api.post('/me/reset-password', email)
      return reset
    },

    async resetPassword({ }, { newPassword, token }) {
      const user = await api.patch(`/me/reset-password/${token}`, { newPassword })
      return user
    },

    async changePassword({ }, { oldPassword, newPassword }) {
      const change = await api.patch('/me/change-password', { oldPassword, newPassword })
      return change
    },

    async updateUser({ }, data) {
      const user = await api.patch(`/users/${data.id}`, data)
      return user
    },

    async getUsers({ }) {
      const users = await api.get('/users')
      return users
    },

    async getUser({ }, { id }) {
      const user = await api.get(`/users/${id}`, {})
      return user
    },

    async createUser({ }, data) {
      const user = await api.post('/users', data)
      return user
    },

    async deleteUser({ }, { id }) {
      const user = await api.delete(`/users/${id}`)
      return user
    },

    async refreshLocations({ commit }) {
      const data = await api.get('/locations', {})
      commit('setLocations', data.locations)
    },

    async getLocation({ }, { id }) {
      const location = await api.get(`/locations/${id}`, {})
      return location
    },

    async createLocation({ dispatch }, data) {
      const location = await api.post('/locations', data)
      await dispatch('refreshLocations')
      return location
    },

    async updateLocation({ dispatch }, data) {
      const result = await api.patch(`/locations/${data.id}`, data)
      await dispatch('refreshLocations')
      return result
    },

    async deleteLocation({ dispatch }, { id }) {
      const location = await api.delete(`/locations/${id}`)
      await dispatch('refreshLocations')
      return location
    },

    async getForm({ }, { id }) {
      const form = await api.get(`/forms/${id}`, {})
      return form
    },

    async createForm({ }, data) {
      const form = await api.post('/forms', data)
      return form
    },

    async updateForm({ }, data) {
      const form = await api.patch(`/forms/${data.id}`, data)
      return form
    },

    async deleteForm({ }, { id }) {
      const form = await api.delete(`/forms/${id}`, {})
      return form
    },

    async getCoupons({ }, param) {
      const query = []
      if (param.locationId) query.push(`?location_id=${param.locationId}`)
      if (param.startDate) query.push(`start_date=${format(param.startDate, 'YYYY-MM-DD')}`)
      if (param.endDate) query.push(`end_date=${format(param.endDate, 'YYYY-MM-DD')}`)
      return api.get(`/coupons${query.join('&')}`, {})
    },

    async createCoupon({ }, data) {
      const coupon = await api.post('/coupons', {
        preview: true,
        form_response: {
          form_id: data.typeform_id,
          answers: [
            {
              type: 'email',
              email: data.email,
            },
          ],
        },
      })
      return coupon
    },
  },
})
